module.exports = __webpack_public_path__ + "img/sv70.b4fc751e.svg";